const MAX_SEEN_KEYS = 512;

const text = (value) => (value == null ? '' : String(value).trim());

const keyForRide = (rideId) => {
  const id = text(rideId);
  if (!id) return null;
  return `ride:${id}`;
};

// Der Leser liefert angebotene Singles getrennt von angebotenen Bundles. Angenommene
// Fahrten sind absichtlich nicht „neu". Ein Bundle zählt als Zahl seiner Fahrten, nicht
// als eine Sammelkarte. Action-/State-Tokens werden nie im Browser-Speicher abgelegt.
export function reservationAttentionKeys(payload) {
  const keys = new Set();
  const offered = Array.isArray(payload?.offered) ? payload.offered : [];
  offered.forEach((ride) => {
    const key = keyForRide(ride?.id);
    if (key) keys.add(key);
  });

  const bundles = Array.isArray(payload?.offered_bundles) ? payload.offered_bundles : [];
  bundles.forEach((bundle) => {
    const members = Array.isArray(bundle?.members) ? bundle.members : [];
    if (members.length) {
      members.forEach((member) => {
        const key = keyForRide(member?.id);
        if (key) keys.add(key);
      });
      return;
    }
    // Fail-soft für einen älteren Server ohne members: das Bundle sichtbar machen,
    // aber keine ungeprüfte count-Zahl vervielfachen.
    const bundleId = text(bundle?.bundle_id);
    if (bundleId) keys.add(`bundle:${bundleId}`);
  });

  return [...keys];
}

export function unseenReservationCount(keys, seen) {
  const known = seen instanceof Set ? seen : new Set();
  return (Array.isArray(keys) ? keys : []).reduce((sum, key) => sum + (known.has(key) ? 0 : 1), 0);
}

export function reservationSeenStorageKey(partnerId) {
  return `voogo:partner:${encodeURIComponent(text(partnerId) || 'unknown')}:reservation-attention:v1`;
}

export function readSeenReservationKeys(storage, storageKey) {
  try {
    const parsed = JSON.parse(storage?.getItem(storageKey) || 'null');
    const values = Array.isArray(parsed) ? parsed : parsed?.keys;
    if (!Array.isArray(values)) return new Set();
    return new Set(values.filter((value) => typeof value === 'string' && value.length <= 500).slice(-MAX_SEEN_KEYS));
  } catch {
    return new Set();
  }
}

export function writeSeenReservationKeys(storage, storageKey, seen) {
  try {
    const keys = [...(seen instanceof Set ? seen : new Set())].slice(-MAX_SEEN_KEYS);
    storage?.setItem(storageKey, JSON.stringify({ version: 1, keys }));
  } catch {
    // Gespeichert wird nur Komfortzustand. Ein gesperrter Browser-Speicher darf das
    // Portal nicht blockieren; innerhalb dieser Sitzung bleibt der Ref maßgeblich.
  }
}
